// extracted by mini-css-extract-plugin
module.exports = {"title":"general-size-guide_title__6MKDw"};